export default __webpack_public_path__ + "static/media/brentley fluted panel.ee53e0d6.png";